<template>
  <pl-dialog
    :header="'Oops!'"
    :headerStyle="'font-weight: bold; font-size: 24px'"
    :maxWidth="'600px'"
    :padding="'20px'"
  >
    <pl-button
      @click.native="handleModalClose"
      style="position: absolute; right: 0; top: 0;"
      class="pl-icon"
    >
      <i class="fa fa-close fa-lg"></i>
    </pl-button>
    <div class="center-xs">
      <div class="mt3 pl-subheading">
        In order to upgrade, your email address
        <br />
        must have one of following suffixes:
      </div>
      <div v-if="emailSuffixesOfSchool.length" class="mt3 admin-users">
        <div v-for="user in emailSuffixesOfSchool" :key="user">
          {{ user }}
        </div>
      </div>
      <div class="mt3 pl-subheading">
        Need to add another suffix? Contact a
        <br />
        Parlay administrator at your school.
      </div>
      <div class="mt3">
        <pl-button
          @click.native="handleModalClose"
          class="pl-primary"
          style="font-size: 16px; padding: 6px 18px;"
        >
          Okay, got it!
        </pl-button>
      </div>
    </div>
  </pl-dialog>
</template>

<!-- JS -->
<script>
  import { mapGetters } from 'vuex';

  export default {
    props: {
      emailSuffixesOfSchool: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    computed: {
      ...mapGetters([]),
    },
    methods: {
      handleModalClose() {
        localStorage.removeItem('showEmailSuffixesBlockModal');
        this.$emit('closeModal');
      },
    },
  };
</script>

<!-- CSS -->
<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
  .admin-users {
    font-size: 16px
    font-weight: 600
    letter-spacing: 0.01em
    line-height: 24px
  }
</style>



// WEBPACK FOOTER //
// emailSuffixBlockModal.vue?f6448564